// Module
var code = "<template><require from=\"../../../../../../components/color-picker/color-picker\"></require><div class=\"row\"><color-picker class=\"margin-bottom col-xs-12 col-xs-gutter\" repeat.for=\"key of keys\" format=\"css\" label.bind=\"key | replaceDashAndCapitalize\" color.two-way=\"model[key]\"></color-picker></div></template>";
// Exports
module.exports = code;